import { REMOVE_RIGHTS_FOR_COMPONENTS, SET_RIGHTS_FOR_COMPONENTS, SET_RIGHTS_INTERNAL } from "./constants";
import type {
    IComponentRightsState,
    IRemoveRightsForComponents,
    ISetRightsForComponentsAction,
    ISetRightsInternal,
    RemoveRightsForComponentsPayload,
    SetRightsForComponentsPayload,
} from "./types";

/**
 * Vytvoří akci pro nastavení práv pro zadané komponenty. Pokud nejsou některá konkrétní práva specifikována,
 * použije se pro ně výchozí hodnota (nebo zůstane předchozí hodnota, pokud již komponenta měla práva nastavená z předchozích akcí).
 * @param rights Práva komponent. Pokud obsahuje práva pro komponentu se stejným id, použije se poslední výskyt.
 */
export const createSetRightsForComponentsAction = (
    rights: SetRightsForComponentsPayload,
): ISetRightsForComponentsAction => ({
    type: SET_RIGHTS_FOR_COMPONENTS,
    payload: rights,
});

/**
 * Interní akce pro nastavení práv pro jednu komponentu. Slouží pro rozpad hromadné akce {@link createSetRightsForComponentsAction}.
 * @param rights Práva pro komponentu.
 */
export const createSetRightsInternal = (
    rights: Partial<IComponentRightsState>,
): ISetRightsInternal => ({
    type: SET_RIGHTS_INTERNAL,
    payload: rights,
});

/**
 * Vytvoří akci k odstranění práv zadaných komponent ze stavu. Slouží pro úklid stavu, když již práva nejsou potřebná.
 * @param ids Pole identifikátorů komponent, jejichž práva se odstraní.
 */
export const createRemoveRightsForComponents = (
    ids: RemoveRightsForComponentsPayload,
): IRemoveRightsForComponents => ({
    type: REMOVE_RIGHTS_FOR_COMPONENTS,
    payload: ids,
});
